import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { InformationHandlerService } from 'app/utils/information-handler.service';
import { environment } from 'environments/environment';
import { HttpService, MessageService, SessionService, LocalStorageService, MenuBreadCrumb } from 'brainloper-ui';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import { Company } from 'app/models2/administration/company';
import { EquipmentType } from 'app/models2/maintenance/equipment-type';
import { BaseResponse } from 'app/models2/commos/base-response';
import { FormDataManagement } from './models/form-data-management';
import { TypeDataCopy } from './models/type-data-copy';

@Component({
  selector: 'app-management-data',
  templateUrl: './management-data.component.html',
  styleUrls: ['./management-data.component.scss'],
})
export class ManagementDataComponent implements OnInit {

  public copyQuestions : boolean = false;
  public dataToSend: FormDataManagement
  public form: UntypedFormGroup;
  public formQuestions: UntypedFormGroup;
  public companies: Array<Company> = [];
  public typeEquipmentFrom: Array<EquipmentType> = []
  public typeEquipmentTo: Array<EquipmentType> = []
  public typeData: Array<TypeDataCopy> = [
    {
      id: 3,
      name: 'Actividades Frecuentes',
      urlGet: `${environment.endpoint}/api/v1/actividadesfrecuentes/combo`,
      urlPost: `${environment.endpoint}/api/v1/actividadesfrecuentes`,
      params: [{ id: 'id_compania', value: 0 }],
    },
    {
      id: 4,
      name: 'Tipo Equipos',
      urlGet: `${environment.endpoint}/api/v1/tipoequipo/combo`,
      urlPost: `${environment.endpoint}/api/v1/tipoequipo`,
      params: [{ id: 'id_compania', value: 0 }],
    },
    {
      id: 6,
      name: 'Cargos',
      urlGet: `${environment.endpoint}/api/v1/cargos/combo`,
      urlPost: `${environment.endpoint}/api/v1/cargos`,
      params: [{ id: 'id_compania', value: 0 }],
    },
    {
      id: 7,
      name: 'Terceros',
      urlGet: `${environment.endpoint}/api/v1/terceros/combo`,
      urlPost: `${environment.endpoint}/api/v1/terceros`,
      urlDetalle: `${environment.endpoint}/api/v1/terceros`,
      params: [{ id: 'id_compania', value: 0 }],
    },
    {
      id: 8,
      name: 'Preguntas preoperacionales',
      urlGet: `${environment.endpoint}/api/v1/preoppreguntas/combo`,
      urlPost: `${environment.endpoint}/api/v1/preoppreguntas`,
      params: [{ id: 'id_compania', value: 0 }],
    },
  ];

  public urlPreo: string = `${environment.endpoint}${EndpointDictionary.PreopResponseType.PREOP_TYPE_RESPONSE_COMBO}`;
  public urlPreoP: string = `${environment.endpoint}${EndpointDictionary.PreopResponse}`;
  private urlGetCompanias: string  = `${environment.endpoint}${EndpointDictionary.Company.COMPANY_COMBO}`;

  public menuBreadCrumb:Array<MenuBreadCrumb> = [
    {
      name:"Inicio",
      router:'/inicio',
    },
    {
    name:"Administracion de datos",
    current:true
  }]

  constructor(
    private http: HttpService,
    private formBuilder: UntypedFormBuilder,
    private session: SessionService,
    private router: Router,
    private copyInfo: InformationHandlerService,
    private RespInfo: InformationHandlerService,
    private message: MessageService,
    private storage : LocalStorageService
  ) {
    let rol: string = this.storage.get<string>('rol');
    if (rol != 'root') {
      sessionStorage.clear();
      this.router.navigate(['/']);
    }
    this.form = this.formBuilder.group({
      companyFrom: '',
      companyTo: '',
      typeDataId: '',
    });

    this.formQuestions = this.formBuilder.group({
      typeEquipmentFrom: 0,
      typeEquipmentTo: 0
    })
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando información');
    this.initValue();
  }

  async handlerData(data: FormDataManagement) {
    this.dataToSend = {
      companyFrom: 0,
      companyTo: 0,
      typeDataId: 0,
    };
    this.dataToSend.companyFrom = parseInt(data.companyFrom.toString());
    this.dataToSend.companyTo = parseInt(data.companyTo.toString());
    this.dataToSend.typeDataId = parseInt(data.typeDataId.toString());

    if (
      this.dataToSend.companyFrom != this.dataToSend.companyTo &&
      this.dataToSend.companyFrom != 0 &&
      this.dataToSend.companyTo != 0 &&
      this.dataToSend.typeDataId != 0
    ) {
      let typeData = this.typeData.find((x) => x.id == this.dataToSend.typeDataId);
      if (typeData.params && typeData.params.length > 0) {
        typeData.params[0].value = this.dataToSend.companyFrom;
      }

      if(typeData.id == 8 && typeData.name == "Preguntas preoperacionales"){
        let paramsMachineType = this.typeData.find((x) => x.id == 4);
        this.typeEquipmentFrom = await this.copyInfo.getData(this.dataToSend.companyFrom, paramsMachineType)
        this.typeEquipmentTo = await this.copyInfo.getData(this.dataToSend.companyTo, paramsMachineType)
        this.copyQuestions = true;
      }else{
        this.copyQuestions = false;
        this.copyInfo.copyData(
          this.dataToSend.companyFrom,
          this.dataToSend.companyTo,
          typeData
        );
      }

    }
  }

  async initValue() {
    try {
     let res: BaseResponse<Array<Company>> = await this.http.getDataPromise(this.urlGetCompanias)
      if (res.code === 0) {
        this.companies = res.body;
        this.message.closeLoading();
      } else {
        this.message.closeLoading();
        this.message.ErrorToast('Error obteniendo compañias');
      }
    } catch (error) {
      this.message.closeLoading();
      this.message.Error('Error', 'Error al cargar la información');
    }
  }

  async createQuestion(data:any){
    console.log(data)
    let paramsType = this.typeData.find((x) => x.id == 8);
    this.copyInfo.CreateQuestions(this.dataToSend.companyFrom, this.dataToSend.companyTo, parseInt(data.typeEquipmentFrom) , parseInt(data.typeEquipmentTo), paramsType)
  }

  Resp(info: FormDataManagement) {
    let infoToSend: FormDataManagement = {
      companyFrom: 0,
      companyTo: 0,
      typeDataId: 0,
    };
    infoToSend.companyFrom = parseInt(info.companyFrom.toString());
    if (infoToSend.companyFrom != 0) {
      this.RespInfo.createPreopResoponce(
        infoToSend.companyFrom,
        this.urlPreo,
        this.urlPreoP
      );
    }
  }
}
